<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="widget">
        <div class="widget-heading -list">
          <h1 class="textStyle">
            {{
              this.$tc("global.list.title", 1, {
                name: this.$tc("studea_manager.group.title", 2).toLowerCase(),
              })
            }}
            {{
              isFiltered
                ? "(" +
                  (maxResult ? maxResult : Object.keys(datas).length) +
                  " résultat" +
                  ((maxResult ? maxResult : Object.keys(datas).length) > 1 ? "s" : "") +
                  " filtré" +
                  ((maxResult ? maxResult : Object.keys(datas).length) ? "s" : "") +
                  ")"
                : ""
            }}
          </h1>
          <div>
            <button
              v-if="isFiltered"
              class="btn-icon me-1 btnReset"
              v-tooltip="{ title: $t('init_search') }"
              type="button"
              @click="resetSearch"
            >
              <FontAwesomeIcon icon="fa-light fa-arrows-rotate" />
            </button>
            <button
              class="btn-icon btnOpen"
              v-tooltip="{ title: $t('search_motor') }"
              type="button"
              @click="openSearch"
            >
              <FontAwesomeIcon icon="fa-light fa-magnifying-glass" />
            </button>
          </div>
        </div>
        <div class="widget-content">
          <SortTableComponent
            :actions="listActions"
            :apiFilters="true"
            :columns="columns"
            :datas="datas"
            :idKey="columns.length"
            statusKey="4"
            :loading="loading"
            :maxResult="maxResult"
            :isSearchAvailable="true"
            :defaultLimit="10"
            linkKey="3"
            linkRouteName="RegistrationList"
            :linkInactiveCondition="{ condition: 0 }"
            queryName="group"
            type="front-group"
            ref="sortTable"
            path="studeaManagerLayout"
            @refresh="refresh"
            @openSearch="openSearch"
            @copyToClipboard="copyToClipboard"
            @createRegistrationSheetView="createRegistrationSheetView"
            @deleteGroup="deleteGroup"
          />
        </div>
      </div>
    </div>
  </div>
  <ModalFormComponent
    :models="models"
    :title="modalTitle"
    :storageKey="sessionStorageKey"
    @search="search"
    @submit="submit"
  />
</template>

<script>
import { trainingManager } from "@/services/training/training-manager";
import SortTableComponent from "@/components/table/sortTable/SortTableComponent.vue";
import { formManager } from "@/services/form/form-manager";
import { sortableTableManager } from "@/services/utilities/sortable-table-manager";
import { mapActions, mapState } from "pinia";
import { useMainStore } from "@/store/main/main";
import ModalFormComponent from "@/components/form/ModalFormComponent.vue";
import { i18n } from "@/i18n";
import { registrationManager } from "@/services/registration/registration-manager";
import { usePlatformStore } from "@/store/platform/platform";
import { notificationManager } from "@/services/utilities/notification-manager";
import { accessConstante } from "@/constantes/access";
import { groupConstante } from "@/constantes/group";

export default {
  name: "TrainingGroupListView",
  components: {
    ModalFormComponent,
    SortTableComponent,
  },
  data() {
    return {
      columns: [],
      models: [],
      modalTitle: "",
      modalType: "",
      loading: false,
      isFiltered: false,
      listParams: [],
      datas: [],
      currentGroupCryptedId: null,
      isSearchOpen: false,
      sessionStorageKey: "studea-front-group",
      maxResult: 0,
    };
  },
  computed: {
    listActions() {
      const actions = [
        {
          icon: "pen",
          type: "primary",
          actionType: "router",
          action: "RegistrationGroupEdit",
          translation: i18n.global.tc("global.edit.title", 1, {
            name: i18n.global.tc("studea_manager.group.title", 1).toLowerCase(),
          }),
          cfaStyle: true,
        },
        {
          icon: "trash",
          type: "danger",
          action: "deleteGroup",
          translation: i18n.global.tc("global.delete.title", 1, {
            name: i18n.global.tc("studea_manager.group.title", 1).toLowerCase(),
          }),
          showCondition: groupConstante.GROUP_STATUS_VALID,
          conditionIndex: 4,
          isConditionInverse: true,
          cfaStyle: false,
          code: accessConstante.STUDEA_MANAGER_TRAINING_GROUP_DELETE,
          access: accessConstante.ALL,
        },
      ];
      if (this.dataVersionIsActive) {
        actions.push(
          {
            icon: "eye",
            type: "primary",
            actionType: "router",
            action: "TrainingPreRegistration",
            translation: i18n.global.t("registration.group_action.see_sheet"),
            cfaStyle: true,
            aliasId: "group",
            showCondition: groupConstante.GROUP_STATUS_VALID,
            conditionIndex: 4,
            params: {
              tab: 0,
            },
          },
          {
            icon: "plus",
            type: "primary",
            action: "createRegistrationSheetView",
            translation: i18n.global.t("registration.group_action.create"),
            cfaStyle: true,
            showCondition: groupConstante.GROUP_STATUS_VALID,
            conditionIndex: 4,
          },
          {
            icon: "copy",
            type: "primary",
            action: "copyToClipboard",
            translation: i18n.global.t("registration.group_action.copy_sheet"),
            cfaStyle: true,
            showCondition: groupConstante.GROUP_STATUS_VALID,
            conditionIndex: 4,
          },
        );
      }
      return actions;
    },

    ...mapState(usePlatformStore, {
      dataVersionIsActive: (store) => store.dataVersionIsActive,
    }),
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.setParams();
      this.getDatas();
    },

    setParams() {
      if (!this.listParams || !Object.keys(this.listParams).length) {
        this.listParams = {
          search: "",
          sortByField: 0,
          sortOrder: "ASC",
          limit: 50,
          offset: 0,
        };
      }
    },

    search(params) {
      if (this.modalType === "search") {
        this.loading = true;
        this.$refs.sortTable.activePage = 1;
        this.listParams["offset"] = 0;
        this.listParams["search"] = params;
        this.getDatas();
        this.isFiltered = true;
      }
    },

    refresh(params) {
      this.listParams = params;
      this.init();
    },

    getFilters() {
      this.loading = true;
      this.models = [];
      this.modalTitle = this.$tc("global.search.title", 2, {
        name: this.$tc("admin.training.title", 2).toLowerCase(),
      });
      this.sessionStorageKey = "studea-front-group";
      trainingManager.form("group/search").then((data) => {
        this.models = data;
        this.modalType = "search";
        this.loading = false;
      });
    },

    openSearch() {
      this.getFilters();
      this.isSearchOpen = true;
    },

    resetSearch() {
      this.listParams = [];
      this.$refs.sortTable.activePage = 1;
      this.datas = [];
      this.columns = [];
      this.isFiltered = false;
      window.sessionStorage.removeItem(this.sessionStorageKey);
      this.init();
    },

    getDatas() {
      if (window.sessionStorage.getItem(this.sessionStorageKey)) {
        this.listParams["search"] = JSON.parse(window.sessionStorage.getItem(this.sessionStorageKey));
        this.isFiltered = true;
      }
      if (this.isFiltered) {
        this.listParams["search"] = formManager.getQuery(this.listParams["search"]);
      }
      trainingManager.groups(this.listParams).then((data) => {
        this.columns = sortableTableManager.getEntriesColumns(data.columns, this.columns);
        if (this.columns && this.columns[5]) {
          this.columns[5].sortable = false;
        }
        this.datas = data.data;
        this.maxResult = data.count;
        this.loading = false;
        this.setAppLoading(false);
      });
    },

    copyToClipboard(payload) {
      registrationManager.copyToClipboard(payload.id);
    },

    createRegistrationSheetView(payload) {
      this.loading = true;
      this.sessionStorageKey = null;
      this.models = [];
      registrationManager.getRegistrationCreateForm().then((res) => {
        this.models = res;
        this.modalTitle = i18n.global.t("registration.group_action.create");
        this.currentGroupCryptedId = payload.id;
        this.modalType = "createRegistration";
        this.loading = false;
      });
    },

    submit() {
      if (this.modalType === "createRegistration") {
        this.loading = true;
        const result = formManager.processForm(this.models);
        const data = { data: result, registrationActorType: null };
        registrationManager.postRegistrationCreateForm(this.currentGroupCryptedId, data);
      }
    },

    async deleteGroup(payload) {
      const alert = await notificationManager.showAlert(
        "question",
        this.$t("registration.group_action.delete.confirmation"),
        "",
        true,
        true,
      );
      if (!alert.isConfirmed) return;
      this.loading = true;
      const response = await trainingManager.delete("group", payload.id);
      if (!response.success) {
        notificationManager.showNotification("error", response.message);
        this.loading = false;
      } else {
        notificationManager.showNotification("success", this.$t("registration.group_action.delete.success"));
        this.init();
      }
    },

    ...mapActions(useMainStore, { setAppLoading: "setAppLoading" }),
  },
};
</script>

<style lang="scss" scoped>
.list {
  &__row {
    border-bottom: 1px dashed $m-color_6;
    padding: 8px 0;
  }

  &__group {
    display: flex;
    align-items: center;
  }

  &__group + &__group {
    margin-top: 10px;
  }
}
</style>
